import request from '@/utils/request'

const url = '/home/backupwarehouse/'
const api = {
  getBackupWarehouseList (data) {
    return request({
      url: url + 'getBackupWarehouseList',
      method: 'post',
      data
    })
  },
  importBackupWar (data) {
    return request({
      url: url + 'importBackupWar',
      method: 'post',
      data
    })
  },
  handleDelete (data) {
    return request({
      url: url + 'handleDelete',
      method: 'post',
      data
    })
  },
  saveBackupWarehouse (data) {
    return request({
      url: url + 'saveBackupWarehouse',
      method: 'post',
      data
    })
  },
  searchGoods (data) {
    return request({
      url: url + 'searchGoods',
      method: 'post',
      data
    })
  },
  export (data) {
    return request({
      url: url + 'export',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/backupWarehouse.js